import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onClickOutside } from '@vueuse/core';
export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationButton',
  props: {
    type: null,
    label: null,
    noReset: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    noContent: {
      type: Boolean
    },
    noConfirm: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    const root = ref();
    onClickOutside(root, () => {
      confirmed.value = false;
    });
    const confirmed = ref(false);
    const type = computed(() => confirmed.value ? 'error' : props.type);
    const label = computed(() => confirmed.value ? translator.t('sure?') : props.label);
    const attrs = computed(() => {
      const data = {
        type: type.value,
        disabled: props.disabled
      };
      if (!props.noContent) {
        Object.assign(data, {
          textContent: label.value
        });
      }
      return data;
    });
    const onClicked = event => {
      if (props.disabled) {
        return;
      }
      if (props.noConfirm) {
        return;
      }
      if (!confirmed.value) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        confirmed.value = true;
        return;
      }
      if (!props.noReset) {
        confirmed.value = false;
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "root",
        ref: root,
        class: "inline-flex",
        onClickCapture: onClicked
      }, [_renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({
        confirmed: confirmed.value,
        type: _unref(type),
        label: _unref(label),
        attrs: _unref(attrs)
      })))], 544);
    };
  }
});